<template>
    <div>
        <div class="jd-upload--warp" :class="{'noImg':fileList.length==0}">
            <k-uploader
                    v-model="fileList"
                    multiple
                    :max-count="8"
                    :max-size="imgMaxSize"
                    @delete="fileDelete"
                    @oversize="oversize"
                    :after-read="afterRead">
                <div area="upload" class="k-uploader__upload">
                    <k-icon name="plus" class="k-uploader__upload-icon"></k-icon>
                    图片({{fileList.length}}/8)
                </div>
            </k-uploader>
        </div>
        <template v-if="tempList.length">
            <form v-for="(item, index) in tempList" :key="index" :id="`js-uploader_form_imgRidFor_${index}`" hcbjump="1" style="display:none">
                <input type="hidden" name="fileFormat" :value="item.file.type|filterType" />
                <input type="hidden" name="_content" :value="item.content|filterContent" />
            </form>
        </template>
    </div>
</template>

<script>
    import {mapActions} from "vuex"
    export default {
        name: "img-upload",
        props : ["imgKey","list"],
        data () {
            return {
                fileList : [
                   /* {
                        content     : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png",
                        imgRid      : 2184,
                        imgUrl      : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png"
                    },{
                        content     : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png",
                        imgRid      : 2185,
                        imgUrl      : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png"
                    },{
                        content     : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png",
                        imgRid      : 2186,
                        imgUrl      : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png"
                    },{
                        content     : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png",
                        imgRid      : 2187,
                        imgUrl      : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png"
                    },{
                        content     : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png",
                        imgRid      : 2188,
                        imgUrl      : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png"
                    },{
                        content     : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png",
                        imgRid      : 2189,
                        imgUrl      : "https://imgcdn-dev.pydp888.com/file/0/1/102165/20200803/3999c7f2b2d2adaf3ba052b843456845.png"
                    },*/
                ],
                imgMaxSize : 18874368, //最大18M
                finishImg: [],
                imgRids : [
                    // 2184,
                    // 2185,
                    // 2186,
                    // 2187,
                    // 2188,
                    // 2189
                ],
                tempList : []
            }
        },
        computed : {
            formId() {
                return `js-uploader_form_imgRidFor${this.imgKey}`;
            }
        },
        filters : {
            filterType(value){
                return value.replace(/image\//g,"")
            },
            filterContent(value){
                return value.replace(/^data:image\/(\w+);base64,/, '')
            }
        },
        methods : {
            ...mapActions("jianding", ["saveImage"]),
            oversize(){
                this.$toast({ message: "图片太大,不可超过5M！" });
            },
            afterRead(data,detail) {
                // 此时可以自行将文件上传至服务器
                console.log(data,detail);
                let list = Array.isArray(data) ? data : [data] ;
                this.tempList = list;
                if(list){
                    this.$toast.loading({message: '上传中...',duration: 0, forbidClick : true});
                    setTimeout(()=>{
                         list.forEach((item, index)=>{
                            const { file } = item;
                            const { size, name } = file;
                            const fileType = /\.(jpe?g|png|gif)$/i.test(name) ? RegExp.$1 : "";
                            if (!fileType) {
                                this.$toast({ message: "图片类型错误！" });
                                return;
                            }
                            const { imgKey } = this;
                            this.$toast.loading({message: '上传中...',duration: 0, forbidClick : true});
                            this.saveImage({
                                formId: `js-uploader_form_imgRidFor_${index}`,
                                fileName: name,
                                fileType,
                                imgKey,
                                imgData: item.content
                            }).then(R=>{
                                let viewIndex = this.fileList.length-list.length+index;
                                if(R.imgRid){
                                    this.imgRids.push(R.imgRid);
                                }
                                this.fileList.splice(viewIndex,1,{
                                    content     : R.imgUrl,
                                    rid         : R.imgRid,
                                    imgUrl      : R.imgUrl
                                })
                                this.$toast.clear();

                            }).catch((err)=>{
                                console.log(err);
                                this.$toast(err.message);
                                let viewIndex = this.fileList.length-list.length+index;
                                this.fileList.splice(viewIndex,1)
                            })
                        })
                    },500)
                }

            },

            fileDelete(file,detail){
                //console.log(file,detail);
                if(file.rid){
                    let index = this.imgRids.indexOf(file.imgRid);
                    this.imgRids.splice(index,1);
                }
            }
        },
        watch: {
            list(nv){
                if(nv){
                    this.fileList = [...nv];
                    let rids = [];
                    nv.forEach((item) => {
                        rids.push(item.rid);
                    });
                    this.imgRids = rids;
                }
            },
            imgRids(nv){
                //console.log(nv)
                this.$emit('success',{imgRids : nv});

            }
        }
    }
</script>

<style scoped>

</style>